// In-page ←. Shells: /recede_historical_location = native pop (Hotwire built-in rule, no request).
// Web: history.back() only if Turbo recorded an in-app entry behind this one, else replace to the fallback.
export const RECEDE_URL = "/recede_historical_location"

export function backAction({ native, restorationIndex, fallbackUrl, forceFallback = false }) {
  if (native) return { type: "visit", url: RECEDE_URL }
  if (!forceFallback && Number(restorationIndex) > 0) return { type: "history" }
  return { type: "replace", url: fallbackUrl }
}
